<template lang="pug">
v-menu(v-model="showMenu" offset-y rounded="lg" :min-width="block ? undefined : '300'" :max-width="block ? undefined : '300'" :close-on-content-click="false" left max-height="444" nudge-bottom="4")
  template(v-slot:activator="{ on }")
    yz-btn(v-on="on" :label="displayText" outlined size="lg" background-color="white" append-icon="$yzi-chevron-down" :block="block" :button-class="block ? 'branch-dropdown--block' : null")
  .white
    v-skeleton-loader(v-if="loading" type="list-item-three-line" width="200")
    div(v-else)
      .sticky-search.white.pa-2
        v-text-field.round-xl(v-model="searchQuery" placeholder="Search branch..." hide-details dense outlined clearable)
      .scrollable-content(style="max-height: 300px; overflow-y: auto;")
        .hover-bg(v-if="!searchQuery" @click="onToggleSelectAll")
          .d-flex.align-center.justify-space-between.px-4.py-3
            .yz-regular-body-sm.font-weight-medium All branches
            v-checkbox(:input-value="isAllSelected" :indeterminate="isIndeterminate" hide-details dense @click.stop="onToggleSelectAll")
          v-divider.basic300
        template(v-if="filteredItems.length")
          .hover-bg(v-for="item in filteredItems" :key="item.id" @click="onToggleItem(item)")
            .d-flex.align-center.justify-space-between.px-4.py-3
              .yz-regular-body-sm {{ item.name }}
              v-checkbox(:input-value="isItemSelected(item)" hide-details dense @click.stop="onToggleItem(item)")
            v-divider.basic300
        template(v-else)
          .px-4.py-3.yz-regular-body-sm.neutral500--text No branch found
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: { default: null },
    block: { type: Boolean, default: false }
  },
  data() {
    return {
      showMenu: false,
      allItems: [],
      loading: false,
      searchQuery: ''
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    companyId() {
      return this.company?.branch_of?.id || this.company?.id
    },
    displayText() {
      if (!this.value || this.value.length === this.allItems.length) return 'All branches'
      if (this.value.length === 0) return 'No branch selected'
      if (this.value.length === 1) return this.value[0].name
      return `${this.value.length} branches selected`
    },
    isAllSelected() {
      return this.allItems.length > 0 && (this.value === null || this.value.length === this.allItems.length)
    },
    isIndeterminate() {
      return this.value !== null && this.value.length > 0 && this.value.length < this.allItems.length
    },
    filteredItems() {
      if (!this.searchQuery || this.searchQuery.trim() === '') return this.allItems
      const q = this.searchQuery.toLowerCase().trim()
      return this.allItems.filter(i => i.name?.toLowerCase().includes(q))
    }
  },
  watch: {
    showMenu(val, oldVal) {
      if (!val && oldVal) {
        this.searchQuery = ''
      }
    }
  },
  mounted() {
    this.fetchBranches()
  },
  methods: {
    async fetchBranches() {
      this.loading = true
      try {
        const resp = await this.$axios.get(`/companies/${this.companyId}/branches`, { params: { os: 'clinic', page_size: -1 } })
        this.allItems = resp.data?.results || []
      } catch {
        this.allItems = []
      } finally {
        this.loading = false
      }
    },
    isItemSelected(item) {
      return this.value === null || this.value.some(v => v.id === item.id)
    },
    onToggleItem(item) {
      const current = this.value === null ? [...this.allItems] : [...this.value]
      const index = current.findIndex(v => v.id === item.id)
      if (index > -1) {
        current.splice(index, 1)
      } else {
        current.push(item)
      }
      this.$emit('input', current.length === this.allItems.length ? null : current)
    },
    onToggleSelectAll() {
      if (this.isAllSelected) {
        this.$emit('input', [])
      } else {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sticky-search {
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.hover-bg:hover {
  background-color: var(--v-neutral200) !important;
  cursor: pointer;
}

.branch-dropdown--block ::v-deep .yz-btn__content {
  justify-content: space-between;
  width: 100%;
}
</style>
